import { render, staticRenderFns } from "./TableShareExp.vue?vue&type=template&id=2458dbd8&scoped=true"
import script from "./TableShareExp.vue?vue&type=script&lang=js"
export * from "./TableShareExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458dbd8",
  null
  
)

export default component.exports